var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pageRoot" }, [
    _c(
      "div",
      { staticClass: "intro" },
      [
        _vm._v(
          "\n\t\tThe MCP endpoint lets AI agents search events and manage filters using personal API tokens, which users create on their\n\t\t"
        ),
        _c("router-link", { attrs: { to: { name: "apiTokens" } } }, [
          _vm._v("API Tokens")
        ]),
        _vm._v(" page.\n\t\tIt is currently "),
        _c("b", [_vm._v(_vm._s(_vm.mcpEnabled ? "enabled" : "disabled"))]),
        _vm._v("; the switch and related options are on the\n\t\t"),
        _c("router-link", { attrs: { to: { name: "adminSettings" } } }, [
          _vm._v("Settings")
        ]),
        _vm._v(" page.\n\t")
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "heading" }, [_vm._v("All API Tokens")]),
    _vm._v(" "),
    _c("div", { staticClass: "bodySection" }, [
      _vm.tokensError
        ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.tokensError))])
        : !_vm.tokens
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _vm.tokens.length === 0
        ? _c("div", [_vm._v("No tokens have been created.")])
        : _c("table", { staticClass: "grid" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.tokens, function(t) {
                return _c(
                  "tr",
                  { key: t.apiTokenId, class: { inactive: !t.active } },
                  [
                    _c("td", [_vm._v(_vm._s(t.userName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(t.name))]),
                    _vm._v(" "),
                    _c("td", [_c("code", [_vm._v(_vm._s(t.prefix) + "…")])]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(t.scopes.join(", ")))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(t.projects ? t.projects.join(", ") : "All"))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.dateStr(t.created)))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          t.lastUsed
                            ? _vm.dateStr(t.lastUsed) + " from " + t.lastUsedIP
                            : "Never"
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(t.expires ? _vm.dateStr(t.expires) : "Never")
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.statusStr(t)))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "actions" },
                      [
                        !t.revoked
                          ? [
                              _c("input", {
                                attrs: { type: "button", value: "Revoke" },
                                on: {
                                  click: function($event) {
                                    return _vm.revoke(t)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              t.scopes.indexOf("sensitive:read") === -1
                                ? _c("input", {
                                    attrs: {
                                      type: "button",
                                      value: "Grant sensitive:read"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSensitive(t, true)
                                      }
                                    }
                                  })
                                : _c("input", {
                                    attrs: {
                                      type: "button",
                                      value: "Remove sensitive:read"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSensitive(t, false)
                                      }
                                    }
                                  })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              }),
              0
            )
          ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "heading" }, [_vm._v("Redaction")]),
    _vm._v(" "),
    _c("div", { staticClass: "bodySection" }, [
      _vm.redactionError
        ? _c("div", { staticClass: "error" }, [
            _vm._v(_vm._s(_vm.redactionError))
          ])
        : !_vm.rules
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _c("div", [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "formRow" }, [
              _c("label", { attrs: { for: "hiddenTagKeys" } }, [
                _vm._v("Hidden tag keys")
              ]),
              _vm._v(" "),
              _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hiddenTagKeys,
                      expression: "hiddenTagKeys"
                    }
                  ],
                  attrs: {
                    id: "hiddenTagKeys",
                    rows: "4",
                    cols: "40",
                    placeholder: "One tag key per line"
                  },
                  domProps: { value: _vm.hiddenTagKeys },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.hiddenTagKeys = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "hint" }, [
                  _vm._v(
                    "These tags are omitted entirely (case-insensitive); the output only lists their names."
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "grid rules" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rules, function(r, i) {
                  return _c("tr", { key: i }, [
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.Enabled,
                            expression: "r.Enabled"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(r.Enabled)
                            ? _vm._i(r.Enabled, null) > -1
                            : r.Enabled
                        },
                        on: {
                          change: function($event) {
                            var $$a = r.Enabled,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(r, "Enabled", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    r,
                                    "Enabled",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(r, "Enabled", $$c)
                            }
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.Name,
                            expression: "r.Name"
                          }
                        ],
                        staticClass: "ruleName",
                        attrs: { type: "text" },
                        domProps: { value: r.Name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(r, "Name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.Pattern,
                            expression: "r.Pattern"
                          }
                        ],
                        staticClass: "pattern",
                        attrs: { rows: "2" },
                        domProps: { value: r.Pattern },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(r, "Pattern", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.TagKeys,
                            expression: "r.TagKeys"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: r.TagKeys },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(r, "TagKeys", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        attrs: { type: "button", value: "Remove" },
                        on: {
                          click: function($event) {
                            return _vm.rules.splice(i, 1)
                          }
                        }
                      })
                    ])
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttonRow" }, [
              _c("input", {
                attrs: { type: "button", value: "Add Rule" },
                on: {
                  click: function($event) {
                    return _vm.rules.push({
                      Name: "",
                      Enabled: true,
                      Pattern: "",
                      TagKeys: ""
                    })
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "button", value: "Restore Default Rules" },
                on: { click: _vm.restoreDefaults }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "button", value: "Save Redaction Settings" },
                on: { click: _vm.saveRedaction }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "testBox" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "formRow" }, [
                _c("label", { attrs: { for: "testTagKey" } }, [
                  _vm._v("Tag key")
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.testTagKey,
                        expression: "testTagKey"
                      }
                    ],
                    attrs: {
                      id: "testTagKey",
                      type: "text",
                      placeholder: "Leave empty to test as a message"
                    },
                    domProps: { value: _vm.testTagKey },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.testTagKey = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.testText,
                    expression: "testText"
                  }
                ],
                staticClass: "testText",
                attrs: {
                  rows: "5",
                  placeholder: "Paste text, e.g. an HTTP header dump"
                },
                domProps: { value: _vm.testText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.testText = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  attrs: { type: "button", value: "Test" },
                  on: { click: _vm.testRedaction }
                })
              ]),
              _vm._v(" "),
              _vm.testOutput !== null
                ? _c("pre", { staticClass: "testOutput" }, [
                    _vm._v(_vm._s(_vm.testOutput))
                  ])
                : _vm._e()
            ])
          ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "heading" }, [_vm._v("Audit Log")]),
    _vm._v(" "),
    _c("div", { staticClass: "bodySection" }, [
      _c("div", { staticClass: "auditFilters" }, [
        _c("label", [
          _vm._v("User "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.auditUser,
                expression: "auditUser"
              }
            ],
            staticClass: "small",
            attrs: { type: "text" },
            domProps: { value: _vm.auditUser },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.auditUser = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("label", [
          _vm._v("Token ID "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.auditTokenId,
                expression: "auditTokenId"
              }
            ],
            staticClass: "tiny",
            attrs: { type: "text" },
            domProps: { value: _vm.auditTokenId },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.auditTokenId = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("label", [
          _vm._v("Tool "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.auditTool,
                expression: "auditTool"
              }
            ],
            staticClass: "small",
            attrs: { type: "text" },
            domProps: { value: _vm.auditTool },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.auditTool = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("label", [
          _vm._v("\n\t\t\t\tPeriod\n\t\t\t\t"),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.auditDays,
                  expression: "auditDays"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.auditDays = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "1" } }, [_vm._v("Last day")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "7" } }, [_vm._v("Last 7 days")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "30" } }, [
                _vm._v("Last 30 days")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "0" } }, [_vm._v("All")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "button", value: "Refresh" },
          on: { click: _vm.loadAudit }
        })
      ]),
      _vm._v(" "),
      _vm.auditError
        ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.auditError))])
        : !_vm.audit
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _vm.audit.length === 0
        ? _c("div", [_vm._v("No matching records.")])
        : _c("table", { staticClass: "grid audit" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.audit, function(r) {
                return _c(
                  "tr",
                  {
                    key: r.McpAuditRecordId,
                    class: { failed: r.Outcome !== "ok" }
                  },
                  [
                    _c("td", { staticClass: "nowrap" }, [
                      _vm._v(_vm._s(_vm.dateStr(r.Date)))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(r.UserName))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(r.TokenName) + " (" + _vm._s(r.ApiTokenId) + ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(r.IPAddress))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(r.ToolName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(r.ProjectName))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "nowrap" }, [
                      _vm._v(_vm._s(r.Outcome))
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(r.DurationMs))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(r.ResultSize))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "args" }, [
                      _c("code", [_vm._v(_vm._s(r.Arguments))]),
                      r.Message
                        ? _c("div", { staticClass: "message" }, [
                            _vm._v(_vm._s(r.Message))
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              }),
              0
            )
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("User")]),
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Token")]),
        _c("th", [_vm._v("Scopes")]),
        _c("th", [_vm._v("Projects")]),
        _c("th", [_vm._v("Created")]),
        _c("th", [_vm._v("Last Used")]),
        _c("th", [_vm._v("Expires")]),
        _c("th", [_vm._v("Status")]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n\t\t\t\tRedaction applies to everything the MCP endpoint returns to tokens that lack the "
      ),
      _c("code", [_vm._v("sensitive:read")]),
      _vm._v(
        " scope.\n\t\t\t\tFilters and searches still see the raw data. Matches of each rule are replaced with "
      ),
      _c("code", [_vm._v("[REDACTED]")]),
      _vm._v(";\n\t\t\t\tif the pattern defines a group named "),
      _c("code", [_vm._v("secret")]),
      _vm._v(", only that group is replaced.\n\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "warning" }, [
      _vm._v(
        "\n\t\t\t\tLimitation: redaction cannot fully stop an agent from learning a redacted value by probing, for example by searching for\n\t\t\t\tguessed values and observing which events match. Searches and filter previews that refer to a "
      ),
      _c("b", [_vm._v("hidden tag")]),
      _vm._v(
        " are\n\t\t\t\trejected, but value patterns only hide text in the output. Use hidden tags for data that must not leave the server.\n\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("On")]),
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Pattern (.NET regular expression)")]),
        _c("th", [
          _vm._v("Only these tags (comma-separated; empty = all text)")
        ]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("b", [_vm._v("Test")]),
      _vm._v(" (uses the rules above, even if not saved yet)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Time")]),
        _c("th", [_vm._v("User")]),
        _c("th", [_vm._v("Token")]),
        _c("th", [_vm._v("IP")]),
        _c("th", [_vm._v("Tool")]),
        _c("th", [_vm._v("Project")]),
        _c("th", [_vm._v("Outcome")]),
        _c("th", [_vm._v("ms")]),
        _c("th", [_vm._v("Size")]),
        _c("th", [_vm._v("Arguments / Message")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }